import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/CannonClashInstructions.module.css';

const CannonClashInstructions = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleTournamentsNavigation = () => {
        onClose();
        navigate('/tournaments');
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>{t('cannonclash.title')}</h2>
                    <button className={styles.closeButton} onClick={onClose}>×</button>
                </div>

                <div className={styles.content}>
                    <div className={styles.section}>
                        <h3>{t('cannonclash.howToJoin.title')}</h3>
                        <ol>
                            <li><strong>{t('cannonclash.howToJoin.join')}</strong> - {t('cannonclash.howToJoin.joinDesc')}</li>
                            <li><strong>{t('cannonclash.howToJoin.receiveDetails')}</strong> - {t('cannonclash.howToJoin.receiveDetailsDesc')}
                                <ul>
                                    <li>{t('cannonclash.howToJoin.roomId')}</li>
                                    <li>{t('cannonclash.howToJoin.matchTime')}</li>
                                </ul>
                            </li>
                            <li><strong>{t('cannonclash.howToJoin.enterMatch')}</strong> - {t('cannonclash.howToJoin.enterMatchDesc')}
                                <ol>
                                    <li>{t('cannonclash.howToJoin.gotoTournaments')} <span onClick={handleTournamentsNavigation} className={styles.tournamentLink}>https://esl.game/tournaments</span></li>
                                    <li>{t('cannonclash.howToJoin.playNow')}</li>
                                    <li>{t('cannonclash.howToJoin.enterRoomId')}</li>
                                    <li>{t('cannonclash.howToJoin.submit')}</li>
                                </ol>
                            </li>
                            <li><strong>{t('cannonclash.gameSetup')}</strong> - {t('cannonclash.gameSetupDesc')}</li>
                            <li><strong>{t('cannonclash.controls_title')}</strong>
                                <ul>
                                    <li>{t('cannonclash.controls.move')}</li>
                                    <li>{t('cannonclash.controls.fire')}</li>
                                </ul>
                            </li>
                            <li><strong>{t('cannonclash.objective_title')}</strong>
                                <ul>
                                    <li>{t('cannonclash.objective.main')}</li>
                                    <li>{t('cannonclash.objective.side')}</li>
                                    <li>{t('cannonclash.objective.center')}</li>
                                </ul>
                            </li>
                        </ol>
                    </div>

                    <div className={styles.section}>
                        <h3>{t('cannonclash.rules.title')}</h3>
                        <ul>
                            <li><strong>{t('cannonclash.rules.formatLabel')}</strong> {t('cannonclash.rules.format')}</li>
                            <li><strong>{t('cannonclash.rules.joiningLabel')}</strong> {t('cannonclash.rules.joining')}</li>
                            <li><strong>{t('cannonclash.rules.noShowLabel')}</strong> {t('cannonclash.rules.noShow')}</li>
                            <li><strong>{t('cannonclash.rules.progressionLabel')}</strong> {t('cannonclash.rules.progression')}</li>
                            <li><strong>{t('cannonclash.rules.nextRoundsLabel')}</strong> {t('cannonclash.rules.nextRounds')}</li>
                            <li><strong>{t('cannonclash.rules.continuationLabel')}</strong> {t('cannonclash.rules.continuation')}</li>
                            <li><strong>{t('cannonclash.rules.rewardsLabel')}</strong> {t('cannonclash.rules.rewards')}</li>
                        </ul>
                    </div>

                    <div className={styles.section}>
                        <h3>{t('cannonclash.notes.title')}</h3>
                        <ul>
                            <li>{t('cannonclash.notes.noDownload')}</li>
                            <li>{t('cannonclash.notes.missingMatch')}</li>
                            <li>{t('cannonclash.notes.eliminated')}</li>
                            <li>{t('cannonclash.notes.roundsDepend')}</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button className={styles.okButton} onClick={onClose}>{t('common.gotIt')}</button>
                </div>
            </div>
        </div>
    );
};

export default CannonClashInstructions;